import TopicListModel from "./models/TopicListModel";

const TopicListStore = {
  name: 'TopicListStore',
  spec: TopicListModel,
  saveLocally: false,
  initialState: {
    topics:[]
  },
};

const stores=[TopicListStore];

export default stores;